import { z } from 'zod';

const purchaseOrderSupplierSchema = z
  .object({
    minOrderAmount: z.number(),
    currentLotSizingAmount: z.number(),
    lotSizingId: z.uuid(),
  })
  .superRefine((supplier, ctx) => {
    if (
      !(supplier.currentLotSizingAmount >= supplier.minOrderAmount) &&
      supplier.currentLotSizingAmount !== 0
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'supplierMinOrderNotReached',
      });
    }
  });

export const createPurchaseOrderSchema = z.object({
  lotSizing: z
    .object({
      id: z.uuid(),
      suppliers: z.array(purchaseOrderSupplierSchema),
    })
    .superRefine((lotSizing, ctx) => {
      const total = lotSizing.suppliers.reduce(
        (sum, s) => sum + s.currentLotSizingAmount,
        0,
      );
      if (total === 0) {
        ctx.addIssue({
          code: 'custom',
          message: 'lotSizingTotalAmountIsZero',
          path: [],
        });
      }
    }),
});

export type CreatePurchaseOrderFormValues = z.input<
  typeof createPurchaseOrderSchema
>;

export type CreatePurchaseOrderFormOutput = z.output<
  typeof createPurchaseOrderSchema
>;
